import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1742fbc0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "news-container"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "body-container"
};
const _hoisted_4 = {
  class: "notice-box"
};
const _hoisted_5 = {
  class: "page-title"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "10px"
  }
}, " 新闻动态 ", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "240",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/da3d44e7cae441d69ad569c33d59ddfc.png",
  alt: ""
}, null, -1));

const _hoisted_8 = ["href"];

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 更多");

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "12",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/0f8fc94c6f1d4c63b1d96ed8c138d919.png",
  alt: ""
}, null, -1));

const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  class: "classify-box"
};
const _hoisted_14 = ["onClick"];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-arrow-down"
}, null, -1));

const _hoisted_16 = {
  class: "news-list"
};
const _hoisted_17 = ["href"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "main-notice-content"
};
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  class: "title"
};
const _hoisted_22 = {
  key: 1,
  class: "notice-list"
};
const _hoisted_23 = ["title"];
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = {
  class: "card-item-bottom"
};
const _hoisted_26 = {
  class: "date"
};
const _hoisted_27 = {
  class: "dd"
};
const _hoisted_28 = ["href"];

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "24",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202408/7e73654d48f84ce99210f9cd4c1d5567.png",
  alt: ""
}, null, -1));

const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  key: 2,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("a", {
    href: `/notice.html?name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
    class: "more"
  }, _hoisted_11, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.classifyList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.classifyId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_14);
  }), 128))], 2), $data.classifyList.length > 7 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["show-more-btn", !$data.hiddenMoreClass && 'hidden']),
    onClick: _cache[0] || (_cache[0] = $event => $data.hiddenMoreClass = !$data.hiddenMoreClass)
  }, [_createTextVNode(_toDisplayString($data.hiddenMoreClass ? "展开" : "收起") + " ", 1), _hoisted_15], 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [$data.mainRecommendNews ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "main-notice",
    target: "_self",
    href: `/noticeDetail.html?type=1&id=${$data.mainRecommendNews.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`
  }, [_createElementVNode("img", {
    src: $data.mainRecommendNews ? $data.mainRecommendNews.news_cover_url : ''
  }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: "main-notice-top",
    title: $data.mainRecommendNews.news_name
  }, [_createElementVNode("div", _hoisted_21, _toDisplayString($data.mainRecommendNews.news_name), 1)], 8, _hoisted_20)])], 8, _hoisted_17)) : _createCommentVNode("", true), $data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: _normalizeClass(["notice-item", {
        'notice-item-h': $data.newsList.length <= 2
      }]),
      style: _normalizeStyle({
        width: $data.mainRecommendNews ? '357px' : '357px'
      }),
      key: index
    }, [_createElementVNode("div", null, [_createElementVNode("div", {
      class: "title",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_23), _createElementVNode("p", {
      class: "new-intro text-overflow-two",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("p", _hoisted_26, [_createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, "DD")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, "YYYY-MM")), 1)]), _createElementVNode("a", {
      href: `/noticeDetail.html?type=1&id=${item.id}&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`
    }, _hoisted_30, 8, _hoisted_28)])], 6);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_Empty, {
    type: "message"
  })]))])])])])])]);
}